import createReducer from '../utils/createReducer';
import actions from './actions';
import {API_STATUS} from '../utils/constants';

const initialState = {
    fetch: null,
    cardIndex: 0, // RecentActivityCarousel
    summaries: []
};

const actionHandlers = {
    [actions.FETCH_RECENT_ACTIVITY_START](state) {
        return {
            ...state,
            fetch: API_STATUS.START
        };
    },

    [actions.FETCH_RECENT_ACTIVITY_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload,
            fetch: API_STATUS.SUCCESS
        };
    },

    [actions.FETCH_RECENT_ACTIVITY_ERROR](state) {
        return {
            ...state,
            fetch: API_STATUS.ERROR
        };
    },
    [actions.REMOVE_RECENT_ACTIVITY_SEARCH](state, {payload}) {
        const summaries = state.summaries.reduce((newSummaries, summary) => {
            if (summary.scratchpadId !== payload.scratchpadId) {
                return newSummaries.concat(summary);
            }
            return newSummaries;
        }, []);

        return {
            ...state,
            summaries
        };
    },
    [actions.REMOVE_RECENT_ACTIVITY_PROPERTY](state, {payload}) {
        const summaries = state.summaries.map((summary) => {
            const newSummary = {...summary};
            if (newSummary.scratchpadId === payload.searchId) {
                newSummary.propertiesSummary.properties = newSummary.propertiesSummary.properties.reduce((properties, property) => {
                    if (property.scratchpadId !== payload.scratchpadId) {
                        return properties.concat(property);
                    }
                    return properties;
                }, []);
            }
            return newSummary;
        });

        return {
            ...state,
            summaries
        };
    },
    // RecentActivityCarousel
    [actions.CHANGE_RECENT_ACTIVITY_CARD_INDEX](state, {payload}) {
        return {
            ...state,
            cardIndex: payload.cardIndex
        };
    }
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/recent-activity/recent-activity-reducer.js